import { withState } from 'recompose';

export default withState('pagination', 'updatePagination', {
  limit: 10,
  offset: 0,
  page: 0
});
